import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { BackofficeUserPaymentMethods } from '#/common/invoices-and-payments/backoffice-user-payment-methods.tsx'
import { PermissionChecker } from '#/components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/users/$userId_/payment-methods')({
  component: function Component() {
    const { userId } = Route.useParams()
    return (
      <PermissionChecker
        requiredPermissions={[
          'user.read',
          'paymentMethod.read',
          anyOfPermissions('contract.read', 'contract.read.relatedOnly', 'contract.read.allowedOnly'),
        ]}
      >
        <BackofficeUserPaymentMethods userId={userId} />
      </PermissionChecker>
    )
  },
})
